module.exports = __webpack_public_path__ + "img/web-element.c73348d9.jpg";